// Messaggio unico per gli esiti di caricamento su Drive (con documenti già presenti).
export const esitoUpload = (data, prefisso = "") => {
  const n = data?.uploaded?.length || 0;
  const d = data?.duplicati?.length || 0;
  const parti = [];
  if (n) parti.push(`${n} documento/i caricato/i su Drive`);
  if (d) parti.push(`${d} già presente/i nella cartella: non duplicato/i`);
  return [prefisso, parti.join(" · ") || "nessun documento nuovo da caricare"].filter(Boolean).join(" · ");
};
